import { useClientStore } from '@/stores/ClientStore'

let tagManagerInstance = {}

export const createGoogleTagManager = {
  install: () => {
    const { getClient } = useClientStore()

    const { client } = getClient()

    window.dataLayer = window.dataLayer || []

    const is_draft = !!window.location.host.match('^draft([a-zA-Z0-9_-]+).koalect.com')
    const container_id = client.value.gtm_container_id
    let is_loaded = false

    const loadTagManager = () => {
      return new Promise((resolve, reject) => {
        if (is_loaded) return resolve()

        const w = window
        const d = document
        const s = 'script'
        const l = 'dataLayer'

        const f = d.getElementsByTagName(s)[0]
        const j = d.createElement(s)

        w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

        j.async = true
        j.src = `https://www.googletagmanager.com/gtm.js?id=${container_id}`
        f.parentNode.insertBefore(j, f)
        j.onload = () => {
          is_loaded = true
          resolve()
        }

        j.onerror = () => reject(new Error('Failed to load Google Tag Manager'))
      })
    }

    const gtag = function () {
      dataLayer.push(arguments)
    }

    const track = event => dataLayer.push(event)

    const reset = () => track({ ecommerce: null })

    const consent = ({ type = 'default', consent = {} }) => gtag('consent', type, consent)

    if (container_id && !is_draft) loadTagManager()

    tagManagerInstance = {
      track,
      reset,
      consent
    }
  }
}

export const useGoogleTagManager = () => tagManagerInstance